module.exports = __webpack_public_path__ + "SHSADCAA/static/media/users-list.6f9f98df.svg";